module.exports = __webpack_public_path__ + "img/HQ-OA-360V02TGL-T.e368e001.jpg";